import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información médica", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-ips"
}, "Nombre IPS", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-headquarter"
}, "Sede de atención", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-policy"
}, "Número de póliza", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-bloodtype"
}, "Tipo de sangre", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "input-ips",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.NameIps,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('NameIps', val)),
                  placeholder: "Ingrese el nombre de la IPS",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "input-headquarter",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.AttentionHeadquarter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('AttentionHeadquarter', val)),
                  placeholder: "Ingrese la sede de atención",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "input-policy",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.PolicyNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('PolicyNumber', val)),
                  placeholder: "Ingrese el número de póliza",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "input-bloodtype",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.BloodType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('BloodType', val)),
                  placeholder: "Ingrese el tipo de sangre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}